/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: paymentMethodsQuery
// ====================================================

export interface paymentMethodsQuery_account_supportedPaymentMethodsv2 {
  paymentProcessor: PaymentSourceBackend;
  method: PaymentSourceType;
}

export interface paymentMethodsQuery_account_paymentSources_details_PaymentSourceBank {
  accountHolderName: string;
  accountType: BankAccountType;
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  bankName: string;
  last4: string;
  ownershipType: BankOwnershipType;
  routingNumber: string;
  verified: boolean;
}

export interface paymentMethodsQuery_account_paymentSources_details_PaymentSourceCard {
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  brand: string | null;
  expiry: string;
  last4: string;
  name: string | null;
}

export interface paymentMethodsQuery_account_paymentSources_details_PaymentSourcePaypal {
  email: string;
}

export type paymentMethodsQuery_account_paymentSources_details =
  | paymentMethodsQuery_account_paymentSources_details_PaymentSourceBank
  | paymentMethodsQuery_account_paymentSources_details_PaymentSourceCard
  | paymentMethodsQuery_account_paymentSources_details_PaymentSourcePaypal;

export interface paymentMethodsQuery_account_paymentSources {
  id: string;
  /**
   * The deatils of the source
   * (will be different shapes depending on type)
   */
  details: paymentMethodsQuery_account_paymentSources_details | null;
  /**
   * The method of payment (bank, card, paypal, ...etc)
   */
  method: PaymentSourceType | null;
  /**
   * The submethod of payment (jcp, american-express, ach, etc)
   */
  submethod: string | null;
}

export interface paymentMethodsQuery_account {
  id: number;
  /**
   * List of supported payment types and their corresponding backends
   */
  supportedPaymentMethodsv2: paymentMethodsQuery_account_supportedPaymentMethodsv2[];
  /**
   * Get a list of payment sources on an account
   */
  paymentSources: paymentMethodsQuery_account_paymentSources[];
}

export interface paymentMethodsQuery {
  account: paymentMethodsQuery_account;
}

export interface paymentMethodsQueryVariables {
  id: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveBankPaymentSource
// ====================================================

export interface SaveBankPaymentSource_saveBankPaymentSource_details_PaymentSourceBank {
  accountHolderName: string;
  accountType: BankAccountType;
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  bankName: string;
  last4: string;
  ownershipType: BankOwnershipType;
  routingNumber: string;
  verified: boolean;
}

export interface SaveBankPaymentSource_saveBankPaymentSource_details_PaymentSourceCard {
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  brand: string | null;
  expiry: string;
  last4: string;
  name: string | null;
}

export interface SaveBankPaymentSource_saveBankPaymentSource_details_PaymentSourcePaypal {
  email: string;
}

export type SaveBankPaymentSource_saveBankPaymentSource_details =
  | SaveBankPaymentSource_saveBankPaymentSource_details_PaymentSourceBank
  | SaveBankPaymentSource_saveBankPaymentSource_details_PaymentSourceCard
  | SaveBankPaymentSource_saveBankPaymentSource_details_PaymentSourcePaypal;

export interface SaveBankPaymentSource_saveBankPaymentSource {
  /**
   * The deatils of the source
   * (will be different shapes depending on type)
   */
  details: SaveBankPaymentSource_saveBankPaymentSource_details | null;
  id: string;
  /**
   * The method of payment (bank, card, paypal, ...etc)
   */
  method: PaymentSourceType | null;
  /**
   * The submethod of payment (jcp, american-express, ach, etc)
   */
  submethod: string | null;
}

export interface SaveBankPaymentSource {
  saveBankPaymentSource: SaveBankPaymentSource_saveBankPaymentSource | null;
}

export interface SaveBankPaymentSourceVariables {
  accountId: number;
  data: BankInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveCardPaymentSource
// ====================================================

export interface SaveCardPaymentSource_saveCardPaymentSource_details_PaymentSourceBank {
  accountHolderName: string;
  accountType: BankAccountType;
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  bankName: string;
  last4: string;
  ownershipType: BankOwnershipType;
  routingNumber: string;
  verified: boolean;
}

export interface SaveCardPaymentSource_saveCardPaymentSource_details_PaymentSourceCard {
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  brand: string | null;
  expiry: string;
  last4: string;
  name: string | null;
}

export interface SaveCardPaymentSource_saveCardPaymentSource_details_PaymentSourcePaypal {
  email: string;
}

export type SaveCardPaymentSource_saveCardPaymentSource_details =
  | SaveCardPaymentSource_saveCardPaymentSource_details_PaymentSourceBank
  | SaveCardPaymentSource_saveCardPaymentSource_details_PaymentSourceCard
  | SaveCardPaymentSource_saveCardPaymentSource_details_PaymentSourcePaypal;

export interface SaveCardPaymentSource_saveCardPaymentSource {
  /**
   * The deatils of the source
   * (will be different shapes depending on type)
   */
  details: SaveCardPaymentSource_saveCardPaymentSource_details | null;
  id: string;
  /**
   * The method of payment (bank, card, paypal, ...etc)
   */
  method: PaymentSourceType | null;
  /**
   * The submethod of payment (jcp, american-express, ach, etc)
   */
  submethod: string | null;
}

export interface SaveCardPaymentSource {
  saveCardPaymentSource: SaveCardPaymentSource_saveCardPaymentSource | null;
}

export interface SaveCardPaymentSourceVariables {
  accountId: number;
  data: CardInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SavePaypalPaymentSource
// ====================================================

export interface SavePaypalPaymentSource_savePaypalPaymentSource_details_PaymentSourceBank {
  accountHolderName: string;
  accountType: BankAccountType;
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  bankName: string;
  last4: string;
  ownershipType: BankOwnershipType;
  routingNumber: string;
  verified: boolean;
}

export interface SavePaypalPaymentSource_savePaypalPaymentSource_details_PaymentSourceCard {
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  brand: string | null;
  expiry: string;
  last4: string;
  name: string | null;
}

export interface SavePaypalPaymentSource_savePaypalPaymentSource_details_PaymentSourcePaypal {
  email: string;
}

export type SavePaypalPaymentSource_savePaypalPaymentSource_details =
  | SavePaypalPaymentSource_savePaypalPaymentSource_details_PaymentSourceBank
  | SavePaypalPaymentSource_savePaypalPaymentSource_details_PaymentSourceCard
  | SavePaypalPaymentSource_savePaypalPaymentSource_details_PaymentSourcePaypal;

export interface SavePaypalPaymentSource_savePaypalPaymentSource {
  /**
   * The deatils of the source
   * (will be different shapes depending on type)
   */
  details: SavePaypalPaymentSource_savePaypalPaymentSource_details | null;
  id: string;
  /**
   * The method of payment (bank, card, paypal, ...etc)
   */
  method: PaymentSourceType | null;
  /**
   * The submethod of payment (jcp, american-express, ach, etc)
   */
  submethod: string | null;
}

export interface SavePaypalPaymentSource {
  savePaypalPaymentSource: SavePaypalPaymentSource_savePaypalPaymentSource | null;
}

export interface SavePaypalPaymentSourceVariables {
  accountId: number;
  data: PaypalInput;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: currencyRulesetQuery
// ====================================================

export interface currencyRulesetQuery_account_currencyRuleset {
  currency: string;
  method: PaymentSourceType;
  processor: PaymentSourceBackend;
  submethod: string;
  submethodDisplay: string;
}

export interface currencyRulesetQuery_account {
  id: number;
  /**
   * List of rules to determine what payment methods can be used to pay in what currencies
   */
  currencyRuleset: currencyRulesetQuery_account_currencyRuleset[];
}

export interface currencyRulesetQuery {
  account: currencyRulesetQuery_account;
}

export interface currencyRulesetQueryVariables {
  accountId: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: isAuthenticated
// ====================================================

export interface isAuthenticated {
  /**
   * Returns `true` if the user is logged in to Zapier, `false` if not.
   */
  isAuthenticated: boolean;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: paymentMethodQuery
// ====================================================

export interface paymentMethodQuery_account_paymentSources_details_PaymentSourceBank {
  accountHolderName: string;
  accountType: BankAccountType;
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  bankName: string;
  last4: string;
  ownershipType: BankOwnershipType;
  routingNumber: string;
  verified: boolean;
}

export interface paymentMethodQuery_account_paymentSources_details_PaymentSourceCard {
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  brand: string | null;
  expiry: string;
  last4: string;
  name: string | null;
}

export interface paymentMethodQuery_account_paymentSources_details_PaymentSourcePaypal {
  email: string;
}

export type paymentMethodQuery_account_paymentSources_details =
  | paymentMethodQuery_account_paymentSources_details_PaymentSourceBank
  | paymentMethodQuery_account_paymentSources_details_PaymentSourceCard
  | paymentMethodQuery_account_paymentSources_details_PaymentSourcePaypal;

export interface paymentMethodQuery_account_paymentSources {
  /**
   * The deatils of the source
   * (will be different shapes depending on type)
   */
  details: paymentMethodQuery_account_paymentSources_details | null;
  id: string;
  /**
   * The method of payment (bank, card, paypal, ...etc)
   */
  method: PaymentSourceType | null;
  /**
   * The submethod of payment (jcp, american-express, ach, etc)
   */
  submethod: string | null;
}

export interface paymentMethodQuery_account_supportedPaymentMethodsv2 {
  method: PaymentSourceType;
  paymentProcessor: PaymentSourceBackend;
}

export interface paymentMethodQuery_account {
  id: number;
  /**
   * Get a list of payment sources on an account
   */
  paymentSources: paymentMethodQuery_account_paymentSources[];
  /**
   * List of supported payment types and their corresponding backends
   */
  supportedPaymentMethodsv2: paymentMethodQuery_account_supportedPaymentMethodsv2[];
}

export interface paymentMethodQuery {
  account: paymentMethodQuery_account;
}

export interface paymentMethodQueryVariables {
  id: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: invoices
// ====================================================

export interface invoices_account_invoices {
  id: string;
  /**
   * Datetime Invoice was created
   */
  createdAt: string;
  /**
   * Is the payment for the Invoice pending
   */
  hasPendingPayment: boolean;
}

export interface invoices_account {
  id: number;
  /**
   * Get a list of invoices on an account
   */
  invoices: invoices_account_invoices[];
}

export interface invoices {
  account: invoices_account;
}

export interface invoicesVariables {
  accountId: number;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createSetupIntentMutation
// ====================================================

export interface createSetupIntentMutation_createSetupIntent {
  setupIntentId: string;
  clientSecret: string;
  processor: PaymentSourceBackend;
}

export interface createSetupIntentMutation {
  createSetupIntent: createSetupIntentMutation_createSetupIntent;
}

export interface createSetupIntentMutationVariables {
  accountId: number;
  processor?: PaymentSourceBackend | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: paymentSource
// ====================================================

export interface paymentSource_details_PaymentSourceBank {
  accountHolderName: string;
  accountType: BankAccountType;
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  bankName: string;
  last4: string;
  ownershipType: BankOwnershipType;
  routingNumber: string;
  verified: boolean;
}

export interface paymentSource_details_PaymentSourceCard {
  addressCity: string | null;
  addressCountry: string | null;
  addressState: string | null;
  addressZip: string | null;
  brand: string | null;
  expiry: string;
  last4: string;
  name: string | null;
}

export interface paymentSource_details_PaymentSourcePaypal {
  email: string;
}

export type paymentSource_details =
  | paymentSource_details_PaymentSourceBank
  | paymentSource_details_PaymentSourceCard
  | paymentSource_details_PaymentSourcePaypal;

export interface paymentSource {
  /**
   * The deatils of the source
   * (will be different shapes depending on type)
   */
  details: paymentSource_details | null;
  id: string;
  /**
   * The method of payment (bank, card, paypal, ...etc)
   */
  method: PaymentSourceType | null;
  /**
   * The submethod of payment (jcp, american-express, ach, etc)
   */
  submethod: string | null;
}

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BankAccountType {
  checking = "checking",
  savings = "savings",
}

export enum BankOwnershipType {
  business = "business",
  personal = "personal",
}

export enum PaymentSourceBackend {
  braintree = "braintree",
  stripe = "stripe",
}

export enum PaymentSourceType {
  bank = "bank",
  card = "card",
  manual = "manual",
  paypal = "paypal",
}

export interface BankInput {
  details: BankInputDetails;
  token: string;
  type?: string | null;
  method: string;
  paymentProcessor?: PaymentSourceBackend | null;
}

export interface BankInputDetails {
  address_city: string;
  address_country: string;
  address_state: string;
  address_zip: string;
}

export interface CardInput {
  details: CardInputDetails;
  token: string;
  type?: string | null;
  method?: string | null;
  paymentProcessor?: PaymentSourceBackend | null;
  setupIntentId?: string | null;
}

export interface CardInputDetails {
  address_city?: string | null;
  address_state?: string | null;
  address_country?: string | null;
  address_zip?: string | null;
  exp_month?: number | null;
  exp_year?: number | null;
  brand?: string | null;
  country?: string | null;
  fingerprint?: string | null;
  funding?: string | null;
  id?: string | null;
  last4?: string | null;
  name?: string | null;
  object?: string | null;
  type?: string | null;
}

export interface PayPalInputDetails {
  addressCountry?: string | null;
  addressState?: string | null;
  addressZip?: string | null;
  email: string;
}

export interface PaypalInput {
  addressCountry?: string | null;
  addressState?: string | null;
  addressZip?: string | null;
  email?: string | null;
  details?: PayPalInputDetails | null;
  type?: string | null;
  method?: string | null;
  token: string;
  paymentProcessor?: PaymentSourceBackend | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
